const qRouter = [
  {
    path: "/",
    meta: { title: "首页" },
    redirect: "/screen",
    hidden: true,
    component: () => import("@/views/Layout"),
    children: [
      // {
      //   path: "home",
      //   name: "Home",
      //   meta: {
      //     title: "首页",
      //   },
      //   component: () => import("@/views/Home"),
      // },
      {
        path: "teamGroup",
        name: "TeamGroup",
        meta: {
          title: "班组管理",
        },
        component: () => import("@/views/teamGroup"),
      },
      {
        path: "/projectInit",
        name: "projectInit",
        meta: {
          title: "项目立项",
        },
        component: () => import("@/views/projectApproval/projectInit"),
      },
      {
        path: "projectApply",
        name: "ProjectApply",
        meta: {
          title: "立项申请",
        },
        component: () => import("@/views/projectApproval/projectApply"),
      },
      {
        path: "projectContractDetails",
        name: "projectContractDetails",
        meta: {
          title: "立项合同详情",
        },
        component: () => import("@/views/projectApproval/projectContractDetails"),
      },
      {
        path: "projectApplyDetail",
        name: "ProjectApplyDetail",
        meta: {
          title: "立项详情",
        },
        component: () => import("@/views/projectApproval/projectApplyDetail"),
      },
      {
        path: "taskDispatch",
        name: "TaskDispatch",
        meta: {
          title: "项目管理",
        },
        component: () => import("@/views/taskDispatch"),
      },
      {
        path: "projectDetail",
        name: "ProjectDetail",
        meta: {
          title: "任务分配",
        },
        component: () => import("@/views/taskDispatch/projectDetail"),
      },
      {
        path: "addTask",
        name: "AddTask",
        meta: {
          title: "新增任务",
        },
        component: () => import("@/views/taskDispatch/addTask"),
      },
      {
        path: "workOrder",
        name: "WorkOrder",
        meta: {
          title: "工单统计",
        },
        component: () => import("@/views/workOrder"),
      },
      {
        path: "workOrderDetail",
        name: "WorkOrderDetail",
        meta: {
          title: "工单详情",
        },
        component: () => import("@/views/workOrder/workOrderDetail"),
      },
      {
        path: "taskDispatchDetail",
        name: "TaskDispatchDetail",
        meta: {
          title: "作业详情",
        },
        component: () => import("@/views/taskDispatch/taskDispatchDetail"),
      },
      {
        path: "carLocation",
        name: "CarLocation",
        meta: {
          title: "车辆实时定位",
        },
        component: () => import("@/views/carLocation"),
      },
      {
        path: "/mapGis",
        name: "map",
        meta: {
          title: "地图",
        },
        component: () => import("@/views/map/mapBaidu"),
      },
    ],
  },
  {
    path: "/mapGisBig",
    name: "map",
    meta: {
      title: "地图",
    },
    component: () => import("@/views/map/mapBaidu"),
  },
  {
    path: "/mapGisLittle",
    name: "map",
    meta: {
      title: "地图",
    },
    component: () => import("@/views/map/mapLittle"),
  },
  {
    path: "/screen",
    name: "Screen",
    meta: {
      title: "管网大屏",
    },
    component: () => import("@/views/screen"),
  },
  {
    path: "/qrCodeCitizen",
    name: "qrCodeCitizen",
    meta: {
      title: "扫码结果",
    },
    component: () => import("@/views/qrCodeCitizen"),
  },
];

export default qRouter;
